import React from "react";
import "../cssFiles/scanlines.css"; // Ensure this file contains the CSS above

const Scanlines = ({ enabled }) => {
  return <div className={`scanlines ${enabled ? "visible" : "hidden"}`}></div>;
};

export default Scanlines;

